import { useMutation } from '@tanstack/react-query';
import { FIVE_SECONDS, showToast, TOAST_ERROR } from 'lib/utils';
import { makeGenerateLocationDescription } from 'main/factories/usecases/ai/remote-generate-location-description';

interface GenerateLocationDescriptionParams {
  locationId: string;
}

export const useGenerateLocationDescription = (options?: GenerateLocationDescriptionParams) => {
  return useMutation({
    mutationFn: async (params: GenerateLocationDescriptionParams) => {
      const generateLocationDescriptionService = makeGenerateLocationDescription(params.locationId);
      const result = await generateLocationDescriptionService.generateDescription(params);

      if (result instanceof Error) {
        throw result;
      }

      return result;
    },
    onError: (error: Error) => {
      showToast(`Error generating location description: ${error.message}`, TOAST_ERROR, FIVE_SECONDS);
    },
    ...options,
  });
};
